<template>
  <stage-modal
    modal-id="stage-modal"
    :form_fields="getStageFields"
    :modal_title="isEdit ? $t('objects.floor_editing') : $t('objects.add_new_floor')"
    :ok_title="isEdit ? $t('generals.save') : $t('generals.create')"
    :def_form_obj="defObj"
    @formSubmit="saveStage"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import stageModal from '@/components/validatedFormModal.vue'

export default {
  components: {
    stageModal,
  },
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    defObj: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters('knowledgeBase', ['GET_STAGE_TYPES']),
    getStageFields() {
      return [
        {
          obj_name: 'type',
          component_name: 'v-select',
          label: this.$t('objects.floor_type'),
          validation_rules: 'required',
          props: {
            options: this.GET_STAGE_TYPES,
            getOptionLabel: option => option.title[this.$i18n.locale],
            reduce: option => option.id,
          },
        },
        {
          obj_name: 'title',
          label: this.$t('objects.name'),
          placeholder: this.$t('objects.name'),
          validation_rules: 'required',
        },
        {
          obj_name: 'price_per_kv',
          label: this.$t('objects.base_price_per_m'),
          placeholder: this.$t('objects.base_price_per_m'),
          validation_rules: 'required',
          props: {
            // type: 'number',
            formatter: value => {
              const newVal = value.replace(/[^0-9]+/ig, '')
              return new Intl.NumberFormat().format(newVal)
            },
          },
        },
      ]
    },
  },
  mounted() {
    this.FETCH_STAGE_TYPES()
  },
  methods: {
    ...mapActions('knowledgeBase', ['FETCH_STAGE_TYPES']),
    ...mapActions('stages', ['ADD_STAGE', 'EDIT_STAGE']),
    saveStage(obj) {
      console.log(obj)
      if (this.isEdit) {
        const {
          price_per_kv, title, type, id,
        } = obj
        const objToSend = {
          price_per_kv: String(price_per_kv).replace(/[^0-9]+/ig, ''),
          title,
          type,
          id,
        }
        this.EDIT_STAGE(objToSend).then(() => {
          this.$_successToast(this.$t('generals.changed'))
          this.$emit('saveSuccess')
          this.$bvModal.hide('stage-modal')
        }).catch(() => {
          this.$_errorToast(this.$t('generals.error'))
        })
      } else {
        const {
          price_per_kv, ...rest
        } = obj
        const objToSend = {
          price_per_kv: String(price_per_kv).replace(/[^0-9]+/ig, ''),
          ...rest,
        }
        this.ADD_STAGE(objToSend).then(() => {
          this.$_successToast(this.$t('generals.added'))
          this.$emit('saveSuccess')
          this.$bvModal.hide('stage-modal')
        }).catch(() => {
          this.$_errorToast(this.$t('generals.error'))
        })
      }
    },
  },
}
</script>

<style>

</style>
